export const log = (message: string, ...args: Array<unknown>) => {
  // eslint-disable-next-line no-console
  console.log(`Yandex AD ${message}`, ...args);
};
